<div class="p-modal-foot01">
  <asw-button
    [disabled]="isDisabled"
    size="s-min-w100"
    [label]="'label.regist' | staticMsg"
    (click$)="onClickApply()"
  ></asw-button>
</div>
